import cn from 'classnames';
import { Typo, Spacer, Spinner } from 'components/ui-kit';
import styles from './aside.module.scss';

type TAsideProps = {
  isSecondary?: boolean;
  title: string | JSX.Element;
  className?: string;
  isLoading?: boolean;
  dataAt?: string;
};

export const Aside = ({
  title,
  isSecondary,
  children,
  className,
  isLoading,
  dataAt,
}: React.PropsWithChildren<TAsideProps>): JSX.Element => {
  return (
    <div
      data-at={dataAt}
      className={cn(className, styles.aside, {
        [styles.asideSecondary]: isSecondary,
        [styles.asideIsLoading]: isLoading,
      })}
    >
      <Typo variant="xl" weight="600" className={styles.asideTitle}>
        {title}
      </Typo>
      <Spacer size={24} />
      {children}
      {isLoading && (
        <div className={styles.isLoadingScreen}>
          <div className={styles.spinnerCountainer}>
            <Spinner className={styles.asideSpinner} />
          </div>
        </div>
      )}
    </div>
  );
};
